<template>
  <div id="positions-modal-parent">
    <Page title="役職管理">
      <template v-slot:content>
        <div class="table-action">
          <div>
            <div class="search-field">
              <SearchField
                @search="onSearch"
                :count="positions && positions.length"
                :tableData="positions"
                :filterColumns="filterColumns"
                :key="renewKey"
              />
            </div>
            <ActionButton title="新規追加" color="default" icon="plus" @click="onAddButtonClick" />
          </div>
        </div>
        <div class="uk-card uk-card-default uk-card-body">
          <Table :header="header" :tableData="positions" @column-click="onColumnClick" />
        </div>
      </template>
    </Page>
    <div class="uk-flex-top position-form-modal" uk-modal ref="modal" container="#positions-modal-parent" :bg-close="false">
      <PositionForm :key="formKey" @submitted="onSubmitted" :position="position" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
@include modal-form;
.search-field {
  margin-right: $spacing-medium;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { IdName as Position } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import PositionForm from "../organisms/PositionForm.vue";
import SearchField from "../atoms/SearchField.vue";
import Store from "../../store";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    PositionForm,
    SearchField
  }
})
export default class Positions extends Vue {
  private readonly storeInstance = Store.getInstance();
  positions: Position[] = [];
  position: Position | null = null;
  formKey = 0;
  header = [
    { title: "役職名", sortable: true, key: "name", width: "expand" },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name"];
  @Ref("modal") modal!: HTMLElement;
  @Ref("form") form!: HTMLElement;
  query = "";
  renewKey = 0;

  private async loadData() {
    this.positions = this.storeInstance.getPositions();
    this.renewKey = Date.now();
  }
  async beforeMount() {
    await this.loadData();
  }
  onAddButtonClick() {
    this.formKey = Date.now();
    this.position = null;
    UIkit.modal(this.modal).show();
  }
  async onSubmitted() {
    UIkit.modal(this.modal).hide();
    await this.storeInstance.getPositionsApi();
    await this.loadData();
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.positions = searchResult;
    } else {
      await this.loadData();
    }
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "edit") {
      this.position = this.positions[location.row];
      this.formKey = Date.now();
      UIkit.modal(this.modal).show();
    }
  }
}
</script>
